/**
 * ClaimsSchemas.js
 * Mapped from ClaimDto.java
 */

export const HospitalclaimFormSchema = [
  {
    id: "cardNumber",
    group: "Policy Holder Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Card Number",
    value: "",
    isRequired: true,
    fieldType: "textfield",
    pattern: /^\d{16}$/,
    patternMessage: "Invalid card number. It should be 16 digits.",
    onKeyDown: (e, value, deps) => {
      if (e.key === "Enter" && value) {
        e.preventDefault();
        deps.onFetchCardDetails(value);
      }
    },
  },
  {
    id: "policyNumber",
    group: "Policy Holder Information",
    label: "Policy",
    disabled: true,
    fieldType: "Text",
    shownOnForm: true,
    width: "60%",
    isRequired: true,
    value: "",
    fieldType: "textfield",
  },
  {
    id: "insureeId",
    group: "Policy Holder Information",
    label: "Insured Person",
    dataType: "Text",
    disabled: false,
    shownOnForm: true,
    width: "60%",
    isRequired: true,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: (deps) => deps.insurees || [],
    loading: (deps) => deps.cardLoading,
  },
  {
    id: "terminalId",
    group: "Claim Details",
    label: "Hospital/Provider",
    fieldType: "autocomplete",
    shownOnForm: true,
    width: "60%",
    isRequired: true,
    valueKey: "id",
    textValue: "label",
    onSearch: (query, deps) => {
      deps.onSearchTerminals(query);
    },
    options: (deps) => deps.terminals || [],
    loading: (deps) => deps.terminalsLoading,
    onInputChange: (searchValue, deps) => {
      if (deps.onSearchTerminals) {
        deps.onSearchTerminals(searchValue);
      }
    },
  },
  {
    id: "policyBenefitId",
    group: "Claim Details",
    label: "Policy Benefit",
    dataType: "Text",
    disabled: false,
    shownOnForm: true,
    width: "60%",
    isRequired: true,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: (deps) => deps.policyBenefits || [],
    loading: (deps) => deps.policyBenefitsLoading,
  },
  {
    id: "billAmount",
    group: "Claim Details",
    dataType: "number",
    shownOnForm: true,
    width: "60%",
    label: "Claim Amount",
    value: 0.0,
    isRequired: true,
    fieldType: "textfield",
    onKeyDown: (e, value, deps, currentFormData) => {
      if (e.key === "Enter" && value) {
        e.preventDefault();
        deps.onCalculateAmount(value, currentFormData);
      }
    },
  },
  {
    id: "amountByInsurance",
    group: "Claim Details",
    dataType: "number",
    shownOnForm: true,
    width: "60%",
    label: "Amount by Insurance",
    value: 0.0,
    isRequired: false,
    disabled: true,
    fieldType: "textfield",
  },
  {
    id: "copayAmount",
    group: "Claim Details",
    dataType: "number",
    shownOnForm: true,
    width: "60%",
    label: "Payable by Beneficiary",
    value: 0.0,
    isRequired: false,
    disabled: true,
    fieldType: "textfield",
  },
  {
    id: "referenceId",
    group: "Claim Details",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Reference",
    value: "",
    isRequired: false,
    fieldType: "textfield",
  },
];

export const hospitalClaimRecord = {
  id: null,
  localId: "",
  cardNumber: "",
  policyNumber: "",
  insureeId: null,
  terminalId: null,
  policyBenefitId: null,
  billAmount: 0,
  amountByInsurance: 0,
  copayAmount: 0,
  referenceId: "",
  status: "PENDING",
  externalErrors: {},
};
